export enum Role {
  Agency = 'agency',
  God = 'god',
  Arbitrator = 'arbitrator',
  HeadOfNetwork = 'head_of_network',
  // Add any other roles here...
}
